module.exports = __webpack_public_path__ + "img/pick3_g.b3ea1c4a.png";